import UnauthorizedScreen from 'components/UnauthorizedScreen/UnauthorizedScreen';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface IUserRolwUnauthorizedScreen {
  label?: string,
  toLogout: Function
}

export default ({label, toLogout}: IUserRolwUnauthorizedScreen) => {
  const { t } = useTranslation();

  return (
    <UnauthorizedScreen
      label={
        label || t('UserRoleUnauthorizedScreen.label')
      }
      callback={
        () => toLogout()
      }
      callbackLabel={
        t('UserRoleUnauthorizedScreen.logoutButton')
      } />
  );
}